<script setup>
import { onMounted, ref, computed } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

const props = defineProps({
  maxSteps: Number,
  step: Number,
  activeStep: Number,
  stepData: Object,
  date: String,
  start: String,
  duration: Number,
  interval: Number,
  user_short: String,
  room_short: String,
});

const endTime = computed(() => {
  if (props.duration == null || props.start == null || props.duration === 0) {
    return "Uhrzeit";
  }
  const endTimeString = new Date(
    new Date("1970/01/01 " + props.start).getTime() + props.duration * 60000
  ).toLocaleTimeString("de-DE", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return `${props.start} - ${endTimeString} Uhr`;
});
</script>

<template>
  <div
    class="
      flex flex-col
      px-8
      py-5
      w-72
      flex-shrink-0
      border-r border-gray-200
      hover:scale-105 hover:bg-white
      relative
    "
  >
    <div
      v-if="activeStep < step"
      class="
        rounded-2xl
        absolute
        left-0
        right-0
        top-0
        bottom-0
        bg-gray-50
        opacity-75
      "
    ></div>

    <div class="flex items-center mb-4">
      <span class="font-light text-lg"
        >Termin {{ step + 1 }}/{{ maxSteps }}</span
      >
      <span
        class="w-3 h-3 rounded-full ml-auto mr-2 inline-block"
        :style="`background-color:${stepData.type.color}`"
      ></span>

      <span
        class="
          px-0.5
          text-slotBadgeBorder
          border border-slotBadgeBorder
          rounded
          mr-2
        "
      >
        {{ props.user_short ?? "Beh" }}
      </span>

      <span
        class="
          px-0.5
          text-slotBadgeBorder
          border border-slotBadgeBorder
          rounded
        "
      >
        {{ props.room_short ?? "Rau" }}
      </span>
    </div>

    <div class="text-s font-semibold mb-2">{{ stepData.type.name }}</div>

    <div class="text-s">
      {{
        date === null
          ? "Datum"
          : new Date(date).toLocaleDateString("de-DE", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
      }}
      <br />
      <!-- {{ start || "Uhrzeit" }} -->
      <!-- {{ `${start} -  Uhr` || "Uhrzeit" }} -->
      {{ endTime }}
    </div>
  </div>
</template>




       